import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { UserContext } from '../../../hooks';
import BookingDetailsCard from './BookingDetailsCard';
import PlayersManagement from './PlayersManagement';
import BookingHistory from './BookingHistory';
import axiosInstance from '../../../services/axiosInstance';
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_SERVER_URL); // Connect to backend WebSocket

export const BookingDetail = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [members, setMembers] = useState([]);
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const response = await axiosInstance.get(`/users/booking/${bookingId}`);

        if (response.success) {
          setBooking(response.booking);
          setPlayers(response.booking.players || []);
        } else {
          toast.error(response.msg || 'No se pudo obtener la reserva.');
          navigate('/bookings');
        }
      } catch (error) {
        console.error('Error al cargar la reserva:', error);
        toast.error('Ocurrió un error al cargar la reserva.');
        navigate('/bookings');
      } finally {
        setLoading(false);
      }
    };

    const fetchMembers = async () => {
      try {
        const response = await axiosInstance.get('/users/all?role=user');
        if (response.success) {
          setMembers(response.users);
        } else {
          console.error('No se pudo cargar la lista de socios.');
        }
      } catch (error) {
        console.error('Error al cargar socios:', error);
      }
    };

    fetchBooking();
    fetchMembers();

    // Listen for WebSocket updates for this booking
    socket.on(`bookingUpdated:${bookingId}`, updatedBooking => {
      console.log('🔄 Reserva actualizada:', updatedBooking);
      setBooking(updatedBooking);
      setPlayers(updatedBooking.players || []);
    });

    // Cleanup listener on component unmount
    return () => {
      socket.off(`bookingUpdated:${bookingId}`);
    };
  }, [bookingId, navigate]);

  if (loading) {
    return <Typography>Cargando detalle de la reserva...</Typography>;
  }

  if (!booking) {
    return <Typography>No se encontró la reserva.</Typography>;
  }

  const currentUserId = user?.id ?? user?._id;
  const bookingOwnerId =
    booking.userBooked?._id ?? booking.userBooked?.id ?? booking.userBooked;
  const isBookingOwner = Boolean(
    currentUserId &&
      bookingOwnerId &&
      String(currentUserId) === String(bookingOwnerId)
  );

  return (
    <Box p={3}>
      <ToastContainer />
      <BookingDetailsCard
        booking={booking}
        setBooking={setBooking}
        players={players}
        isBookingOwner={isBookingOwner}
      />
      <PlayersManagement
        booking={booking}
        setBooking={setBooking}
        players={players}
        setPlayers={setPlayers}
        members={members}
        user={user}
        isBookingOwner={isBookingOwner}
      />
      <BookingHistory bookingId={bookingId} />
    </Box>
  );
};

export default BookingDetail;
